<div class="company-filters">
  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="skeleton-search">
      <div class="skeleton-shimmer"></div>
    </div>
    <div class="skeleton-list">
      <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8]">
        <div class="skeleton-checkbox"><div class="skeleton-shimmer"></div></div>
        <div class="skeleton-text" [style.width.%]="40 + (i * 13) % 35"><div class="skeleton-shimmer"></div></div>
      </div>
    </div>
  </div>

  <!-- Search Bar -->
  <div class="search-section" *ngIf="!isLoading">
    <div class="search-wrapper">
      <svg class="search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <input type="text"
             class="search-input"
             placeholder="Search by FIT"
             [value]="searchTerm"
             (input)="onSearchChange($event)">
      <svg *ngIf="searchTerm" class="clear-search-icon" (click)="clearSearch()" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <!-- Company List -->
  <div class="company-list" *ngIf="!isLoading">
    <div class="company-item"
         *ngFor="let company of getFilteredItems()"
         (click)="toggleSelection(company)">
      <div class="checkbox" [class.checked]="company.selected">
        <svg *ngIf="company.selected" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <span class="item-name">{{ company.name }}</span>
    </div>

    <!-- No Results Message -->
    <div class="no-results" *ngIf="getFilteredItems().length === 0 && searchTerm">
      <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z" stroke="#868C98" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="no-results-text">No results found</span>
    </div>
  </div>
</div>